var render, staticRenderFns
import script from "./ModalGenericMixin.vue?vue&type=script&lang=js"
export * from "./ModalGenericMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676d5533')) {
      api.createRecord('676d5533', component.options)
    } else {
      api.reload('676d5533', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/ModalGenericMixin.vue"
export default component.exports